module.exports = __webpack_public_path__ + "media/only.f0b29f91.mp4";